import React, { useEffect, useState, useRef } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import NavDropdown from "react-bootstrap/NavDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMagnifyingGlass,
  faPhone,
  faPhoneAlt,
  faShoppingCart,
  faTimes,
  faUser,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import SignInModal from "../components/SignInModal";
import SignUpModal from "../components/SignUpModal";
import CartDetailsModal from "../components/CartDetailsModal";
import dataJson from "../_library/courses.json";
import CourseDetailsModal from "../components/CourseDetailsModal";

import {
  IsAuthenticated,
  GetUserInfo,
  Logout,
  UpdateUserInfo,
} from "../services/api_auth";
import {
  StripeCreateCustomer,
  StripeSubscriptionPayment,
  StripeCancelSubscription,
  PhonePeSubscriptionPayment,
  StripeRefreshSubscriptionsList,
  GetPreSignedUrl,
} from "../services/api_payments";
import { debounce } from "lodash";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../_config/config";
import cc from "classcat";

const ToggleButton = ({ isOn, toggle }) => (
  <div className="sbtn" onClick={() => toggle(!isOn)}>
    <div
      className={cc({
        circlee: true,
        off: !isOn,
        on: isOn,
      })}
    />
    <span className={cc({ textOff: !isOn })}>{isOn ? "$" : "₹"}</span>
  </div>
);

function Header({
  isLoggedIn,
  setIsLoggedIn,
  removeFromCart,
  cartItemCount,
  isUSDCurrency,
  toggleCurrency,
  getCartItems,
  emptyCart,
}) {
  const [showSignIn, setShowSignIn] = useState(false);
  const [showCourseInfoModal, setShowCourseInfoModal] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [courseData, setCourseData] = useState(null);
  const [Username, setUsername] = useState(null);

  const [isScrolled, setIsScrolled] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(0);
  const navigate = useNavigate();

  const [showNavList, setShowNavList] = useState(true);
  const searchInputRef = useRef(null);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [searchIndex, setSearchIndex] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Event handler for hiding nav list when search input is clicked
  const handleSearchInputClick = () => {
    setShowNavList(false);
    setIsInputFocused(true);
  };

  // Event handler for showing nav list when focus moves away from search input
  const handleSearchInputBlur = () => {
    setTimeout(() => {
      setShowNavList(true);
      setIsInputFocused(false);
    }, 150);
  };

  useEffect(() => {
    // Run once on mount
    const prepareIndex = () => {
      if (!dataJson?.CoursesCollection) return;

      const lightweightIndex = dataJson.CoursesCollection.map((course) => ({
        id: course.CourseId,
        title: course.CourseTitle || "",
        category: course.CourseCategory || "",
        image: course.CourseImageURL200H || course.CourseImageURL100x100 || "",
      }));

      setSearchIndex(lightweightIndex);
    };

    prepareIndex();
  }, []);

  useEffect(() => {
    function handleScroll() {
      const currentScrollY = window.scrollY;
      const scrollThreshold = 100; // You can adjust this threshold as needed
      const scrolledUp = currentScrollY < prevScrollY;

      setIsScrolled(scrolledUp);
      setPrevScrollY(currentScrollY);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollY]);

  const targetRef = useRef(null);

  // handle sign in modal
  const handleSignInClose = (...params) => {
    if (params.length !== 0) {
      setAuthState(true, params[1]);
      //AcquireOwnedProducts();
      CreateStripeCustomer();
    }
    setShowSignIn(false);
  };

  const handleSignInCreateButton = () => {
    setShowSignIn(false);
    setShowSignUp(true);
  };
  const handleSignInShow = () => setShowSignIn(true);
  const handleSignUpShow = () => setShowSignUp(true);
  // handle sign up modal
  const handleSignUpLoginButton = () => {
    setShowSignIn(true);
    setShowSignUp(false);
  };
  const handleSignUpClose = (...params) => {
    if (params.length !== 0) {
      setAuthState(true, params[1]);
      //AcquireOwnedProducts();
      CreateStripeCustomer();
    }
    setShowSignUp(false);
  };

  // Update authentication state in local storage with a 2-hour expiry
  const setAuthState = (loggedIn, username) => {
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + 2 * 60 * 60 * 1000); // 2 hours expiry
    const token = sessionStorage.getItem("session_token");
    const refreshtoken = sessionStorage.getItem("session_refresh_token");
    if (token && refreshtoken) {
      localStorage.setItem(
        "authState",
        JSON.stringify({ loggedIn, refreshtoken, expiry, token }),
      ); //
    }
    setUsername(username);
    setIsLoggedIn(loggedIn);
  };

  // handle search info modal
  const handleCartClose = () => setShowCart(false);

  const handleCartShow = () => {
    // Fetch or update the cart items as needed
    console.log("I am called again");
    const updatedCartItems = getCartItems();
    setCartItems(updatedCartItems);
    setShowCart(true);
  };

  // Use useEffect to watch for changes in cartItems and update the state accordingly
  useEffect(() => {
    const updatedCartItems = getCartItems();
    setCartItems(updatedCartItems);
  }, [getCartItems]);

  // course information modal
  const handleCourseInfoModalClose = () => {
    setShowCourseInfoModal(false);
    setCourseData(null);
    searchInputRef.current.value = "";
  };
  const handleCourseInfoModalShow = () => setShowCourseInfoModal(true);

  async function CancelStripeSubscription(subscriptionId) {
    await StripeCancelSubscription(subscriptionId, {
      onSuccess: async (url) => {
        console.log("CancelStripeSubscription " + JSON.stringify(url));
        window.location = url;
      },
      onError: (e) => console.log("CancelStripeSubscription err: " + e),
    });
  }

  const handleSearchClick = (slimItem) => {
    if (!slimItem?.id) {
      console.warn("Clicked item missing id", slimItem);
      return;
    }

    // Find the full course by CourseId
    const fullCourse = dataJson?.CoursesCollection?.find(
      (c) => c.CourseId === slimItem.id,
    );

    if (!fullCourse) {
      console.warn(`Course not found for id: ${slimItem.id}`);
      // Optional: show toast / error message to user
      return;
    }

    // Now pass the REAL full object everywhere else expects
    setCourseData(fullCourse);
    handleCourseInfoModalShow();
  };

  async function DoLogout() {
    Logout({
      onSuccess: () => {
        setUsername(null);
        setAuthState(false);
        localStorage.removeItem("authState");
      },
      onError: (e) => console.log(e),
    });
  }

  async function CreateStripeCustomer() {
    await StripeCreateCustomer({
      onSuccess: async (data) => {
        console.log("CreateCustomer " + JSON.stringify(data));
      },
      onError: (e) => console.log("CreateCustomer err: " + e),
    });
  }

  useEffect(() => {
    //setTimeout(()=>{CreatePhonePeSubscription("price_1OUnKNSCbgFHXELDZ6zIVCFz","title",230,"currency",12)},  3000);
    //setTimeout(()=>{CreateStripeSubscription("price_1OUnKNSCbgFHXELDZ6zIVCFz","title",23,"currency",12)},  3000);
    console.log("Course Details Page...");
    const GetUserInfoIfAuthenticated = async () => {
      await IsAuthenticated({
        onSuccess: async (isAuthenticated) => {
          if (isAuthenticated) {
            await GetUserInfo({
              onSuccess: (data) => {
                console.log("AAA" + JSON.stringify(data));

                setAuthState(true, data.userName);
                //AcquireOwnedProducts();
                CreateStripeCustomer();
                console.log("Header Login " + isLoggedIn);
              },
              onError: (e) => console.log("GetUserInfo err: " + e),
            });
          }
        },
        onError: (e) => console.log("IsAuthenticated err: " + e),
      });
    };

    GetUserInfoIfAuthenticated();

    function handleClickOutside(event) {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        setIsSearch(false);
        searchInputRef.current.value = "";
      }
    }
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setIsLoggedIn, setUsername]);

  useEffect(() => {
    console.log("Header Login " + isLoggedIn);
  }, [isLoggedIn]);

  useEffect(() => {
    // Check if 'linkTo' exists in localStorage and its value is 'ourcourse'
    console.log("check for ourcourse");

    // Delay the execution by 5 seconds
    const delay = 2000; // 5 seconds in milliseconds
    const timeoutId = setTimeout(() => {
      const linkTo = localStorage.getItem("linkTo");
      if (linkTo) {
        const targetElement = document.getElementById(linkTo);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
        // Clear the 'linkTo' value after scrolling
        localStorage.removeItem("linkTo");
      }
    }, delay);

    // Clean up the timeout
    return () => clearTimeout(timeoutId);
  }, []);

  const handleAnchorClick = (event, targetId) => {
    event.preventDefault();

    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    } else {
      // Redirect to index page
      localStorage.setItem("linkTo", targetId);
      window.location.href = "/";
    }
  };
  const debouncedSearch = useRef(
    debounce((value, index) => {
      if (value.length < 3) {
        setSearchData([]);
        setSearchTerm("");
        setIsSearch(false);
        return;
      }

      const lower = value.toLowerCase();
      setSearchTerm(value); // ← save original typed text (case preserved)

      const results = index.filter((item) => {
        const title = (item.title || "").toLowerCase();
        const category = (item.category || "").toLowerCase();
        return title.includes(lower) || category.includes(lower);
      });

      setSearchData(results);
      setIsSearch(true);
    }, 180),
  ).current;

  function highlightMatch(text, query) {
    if (!query || !text) return text || ""; // safe early return

    const regex = new RegExp(
      `(${query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
      "gi",
    );

    return text.split(regex).map((part, i) =>
      regex.test(part) ? (
        <mark key={i} className="bg-warning bg-opacity-50 px-1 rounded">
          {part}
        </mark>
      ) : (
        part
      ),
    );
  }

  const renderSearchResults = () => (
    <div
  ref={targetRef}
  className="position-absolute bg-white shadow-lg rounded-3"
  style={{
    top: "calc(100% + 8px)",
    left: 0,
    width: "max-content",
    minWidth: "100%",
    maxWidth: "min(640px, calc(100vw - 40px))",
    zIndex: 1050,
    border: "1px solid #dee2e6",
    borderRadius: "0.375rem",
    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
  }}
>
  <div
    style={{
      maxHeight: "420px",
      overflowY: "auto",
      overflowX: "hidden",
      WebkitOverflowScrolling: "touch",
      paddingRight: "4px",           // prevent scrollbar overlap with content
    }}
  >
      {searchData.length === 0 ? (
        <div className="p-4 text-center text-muted small">
          No courses found for "{searchInputRef.current?.value || searchTerm}"
        </div>
      ) : (
        <>
          <div style={{ paddingBottom: "50px" }}>
            {" "}
            {/* ← padding to push footer down */}
            {searchData.map((item) => {
              const titleLower = (item.title || "").toLowerCase();
              const categoryLower = (item.category || "").toLowerCase();
              const queryLower = searchTerm.toLowerCase();

              const shouldHighlightTitle = titleLower.includes(queryLower);
              const textToHighlight = shouldHighlightTitle
                ? item.title
                : item.category;

              return (
                <div
                  key={item.id}
                  className="d-flex align-items-start gap-3 px-3 py-2 list-group-item-action cursor-pointer hover-bg-light"
                  role="button"
                  tabIndex={0}
                  onMouseDown={() => handleSearchClick(item)}
                  onKeyDown={(e) =>
                    e.key === "Enter" && handleSearchClick(item)
                  }
                >
                  <div className="flex-shrink-0 mt-1">
                    {item.image ? (
                      <img
                        src={item.image}
                        alt={item.title}
                        width={48}
                        height={48}
                        className="rounded object-cover border border-light-subtle"
                        loading="lazy"
                        onError={(e) =>
                          (e.target.src = "/images/course-placeholder.jpg")
                        }
                      />
                    ) : (
                      <div
                        className="bg-light rounded d-flex align-items-center justify-content-center"
                        style={{ width: 48, height: 48 }}
                      >
                        <small className="text-muted fs-6">?</small>
                      </div>
                    )}
                  </div>

                  <div className="flex-grow-1">
                    <div
                      className="fw-medium text-dark"
                      style={{
                        lineHeight: 1.4,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {highlightMatch(textToHighlight, searchTerm)}
                    </div>
                    <small
                      className="text-muted d-block mt-1"
                      style={{
                        lineHeight: 1.3,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {shouldHighlightTitle
                        ? item.category
                        : highlightMatch(item.category, searchTerm)}
                    </small>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Always visible footer with count – even when scrolled */}
          <div
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "white",
              borderTop: "1px solid #dee2e6",
              padding: "0.5rem 1rem",
              textAlign: "center",
              fontSize: "0.875rem",
              color: "#6c757d",
              zIndex: 1,
            }}
          >
            {searchData.length} course{searchData.length !== 1 ? "s" : ""} found
          </div>
        </>
      )}
    </div>
    </div>
  );

  return (
    <>
      <header className="fixed-nav">
        {/* <!-- ========== HEADING ==========--> */}
        <Navbar expand="lg" variant="light">
          <div className="nav-top">
            <Container>
              <div className="nav-container">
                <div className="logo">
                  <img
                    width="70"
                    height="70"
                    src="./images/svg/sb-icon.svg"
                    alt="logo"
                  />
                  <img
                    width="147"
                    height="70"
                    src="./images/svg/sb-logo.svg"
                    alt="logo"
                  />
                </div>

                <Navbar.Toggle aria-controls="navbarSupportedContent" />
                <div className="nav-container desktop">
                  {showNavList && (
                    <ul className="nav-list">
                      {/* <li className="nav-link">
                        <Link className="item-link" to="/Professionals">
                          Professionals
                        </Link>
                      </li>
                      <li className="nav-link">
                        <Link className="item-link" to="/CollegeStudents">
                          College Students
                        </Link>
                      </li>
                      <li className="nav-link">
                        <NavDropdown title="Kids" id="basic-nav-dropdown">
                          <NavDropdown.Item as={Link} to="/Class5th">
                            Class 5th onwards
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/Class7th">
                            Class 7th onwards
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/Class10th">
                            Class 10th onwards
                          </NavDropdown.Item>
                        </NavDropdown>
                      </li> */}
                    </ul>
                  )}
                  <div className="search position-relative">
                    <form>
                      <input
                        type="search"
                        placeholder="Search"
                        id="searchInput"
                        ref={searchInputRef}
                        autoComplete="off"
                        onClick={handleSearchInputClick} // Click event to hide nav list
                        onBlur={handleSearchInputBlur}
                        onChange={(e) => {
                          const val = e.target.value.trim();
                          debouncedSearch(val, searchIndex);
                        }}
                        style={{
                          width: isInputFocused ? "470px" : "217px", // Initially hidden
                          maxWidth: "470px",
                          opacity: isInputFocused ? "1" : "1", // Initially hidden
                          transition: "width 0.3s, opacity 0.3s",
                        }}
                      />
                      {!isSearch ? (
                        <span type="submit" aria-label="submit">
                          <FontAwesomeIcon icon={faMagnifyingGlass} />
                        </span>
                      ) : null}
                    </form>
                    {isSearch ? renderSearchResults() : null}
                  </div>
                </div>
                <div className="buttons-container">
                  <div className="sbtnbx">
                    <ToggleButton
                      isOn={isUSDCurrency}
                      toggle={toggleCurrency}
                    />
                  </div>
                  {Username ? (
                    <button
                      className="buy circle"
                      type="button"
                      onClick={handleCartShow}
                    >
                      <FontAwesomeIcon icon={faShoppingCart} />
                      {cartItemCount > 0 && (
                        <span className="cart-counter">{cartItemCount}</span>
                      )}
                    </button>
                  ) : (
                    <></>
                  )}
                  {Username == null ? (
                    <>
                      <button
                        className="user circle"
                        type="button"
                        onClick={handleSignInShow}
                      >
                        <FontAwesomeIcon icon={faUser} />
                      </button>
                      <button
                        className="btn primary hideon-mobile"
                        type="button"
                        onClick={handleSignUpShow}
                      >
                        Sign up
                      </button>
                    </>
                  ) : (
                    <>
                      <NavDropdown
                        title={
                          <div className="user-circle-dropdown">
                            <div className="user-circle">
                              {Username.charAt(0)}
                            </div>
                          </div>
                        }
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item>{Username}</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/my-profile">
                          My Profile
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          onClick={(e) => handleAnchorClick(e, "mycoursestart")}
                        >
                          My Courses
                        </NavDropdown.Item>
                        <NavDropdown.Item onClick={DoLogout}>
                          Logout
                        </NavDropdown.Item>
                      </NavDropdown>
                    </>
                  )}
                </div>

                <Navbar.Collapse id="navbarSupportedContent">
                  <div className="navContent">
                    <ul className="nav-list">
                      <li className="nav-link">
                        <Link className="item-link" to="/Professionals">
                          Professionals
                        </Link>
                      </li>
                      <li className="nav-link">
                        <Link className="item-link" to="/CollegeStudents">
                          College Students
                        </Link>
                      </li>
                      <li className="nav-link">
                        <NavDropdown title="Kids" id="basic-nav-dropdown">
                          <NavDropdown.Item as={Link} to="/Class5th">
                            Class 5th onwards
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/Class7th">
                            Class 7th onwards
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/Class10th">
                            Class 10th onwards
                          </NavDropdown.Item>
                        </NavDropdown>
                      </li>
                    </ul>
                    <div className="search position-relative">
                      <form>
                        <input
                          type="search"
                          placeholder="Search"
                          id="searchInputSignup"
                          ref={searchInputRef}
                          autoComplete="off"
                          onChange={(e) => {
                            const val = e.target.value.trim();
                            debouncedSearch(val, searchIndex);
                          }}
                        />
                        {!isSearch ? (
                          <span type="submit" aria-label="submit">
                            <FontAwesomeIcon icon={faMagnifyingGlass} />
                          </span>
                        ) : null}
                      </form>
                      {isSearch ? renderSearchResults() : null}
                    </div>
                  </div>
                  <div className="closeNav">
                    <Navbar.Toggle className="border-0">
                      <FontAwesomeIcon className="text-white" icon={faTimes} />
                    </Navbar.Toggle>
                  </div>
                </Navbar.Collapse>
              </div>
            </Container>
          </div>

          <div className="nav-bottom">
            <div className="container">
              <div className="nav-container">
                <ul className="nav-list">
                  <li className="nav-link">
                    <a className="item-link" href="/">
                      <i className="far fa-home-code">
                        <FontAwesomeIcon icon={faHome} />
                      </i>
                    </a>
                  </li>
                  <li className="nav-link">
                    <a
                      className="item-link"
                      href="#ourcourse"
                      onClick={(e) => handleAnchorClick(e, "ourcourse")}
                    >
                      Courses
                    </a>
                  </li>
                  <li className="nav-link">
                    <NavDropdown title="App" id="basic-nav-dropdown">
                      <NavDropdown.Item
                        href="https://skillbakery.com/mobileapp.apk"
                        download
                      >
                        <img src="./images/play-store.svg" className="" />{" "}
                        Google Play Store
                      </NavDropdown.Item>
                      {/* <NavDropdown.Item as={Link} to=""><img src='./images/app-store.svg' className='' /> App Store</NavDropdown.Item> */}
                    </NavDropdown>
                  </li>
                  <li className="nav-link">
                    <a
                      className="item-link"
                      href="https://blog.skillbakery.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Blog
                    </a>
                  </li>
                  <li className="nav-link">
                    <Link className="item-link" to="/learning-path">
                      Learning Path
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Navbar>
      </header>

      <SignInModal
        show={showSignIn}
        handleClose={handleSignInClose}
        handleCreateButtonClicked={handleSignInCreateButton}
      />
      <SignUpModal
        show={showSignUp}
        handleClose={handleSignUpClose}
        handleLoginButtonClicked={handleSignUpLoginButton}
      />
      <CartDetailsModal
        show={showCart}
        handleClose={handleCartClose}
        removeFromCart={removeFromCart}
        cartItems={cartItems}
        isUSDCurrency={isUSDCurrency}
        getCartItems={getCartItems}
        emptyCart={emptyCart}
      />

      {courseData ? (
        <CourseDetailsModal
          courseData={courseData}
          show={showCourseInfoModal}
          handleClose={handleCourseInfoModalClose}
        />
      ) : null}
    </>
  );
}

export default Header;
